import { useEffect, useMemo, useState } from "react";
import { useAddNewLabelMutation, useGetLabelsQuery } from "./labelsApiSlice";

import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import FormControl, { useFormControl } from "@mui/material/FormControl";

import ShortCutLabelsList from "./ShortCutLabelsList";
import OutlinedInput from "@mui/material/OutlinedInput";

function AddNewLabelBtn(props) {
  const { filled } = useFormControl() || {};
  const addBtn = useMemo(() => {
    return filled && <AddOutlinedIcon />;
  }, [filled]);

  return (
    <div>
      <Button
        aria-label="add"
        size="small"
        startIcon={addBtn}
        onClick={() => props.onAddClick()}
      >
        {props.label}
      </Button>
    </div>
  );
}
//later will compare our chosen labels from each note
function ShortCutLabelsForm(props) {
  const { data: labels, isSuccess } = useGetLabelsQuery("labelsList", {
    pollingInterval: 60000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });
  const [newLabel, setNewLabel] = useState("");
  const [labelsList, setLabelsList] = useState([]);

  const [
    addNewLabel,
    {
      isSuccess: isAddSuccess,
      isError: isAddError,
      error: errorAdd,
      reset: resetAdd,
    },
  ] = useAddNewLabelMutation("LIST");
  const errClass = isAddError ? "errmsg" : "offscreen";
  function checkedLabels(labelId) {
    if (Array.isArray(labelsList)) {
      return labelsList.some((e) => e._id === labelId);
    }
  }
  async function onAddNewLabelClicked() {
    const { data: result } = await addNewLabel({
      name: newLabel,
      author_id: props.authorId,
    });
    if (result !== undefined) {
      props.handleCheckedLabels({ _id: result.id, name: newLabel });
    }
  }
  useEffect(() => {
    setLabelsList(props.labels);
  }, [props.labels]);
  useEffect(() => {
    if (isAddSuccess) {
      setNewLabel("");
      resetAdd();
    }
  }, [resetAdd, isAddSuccess]);
  let content;
  if (isSuccess) {
    const { ids } = labels;
    content = (
      <div className="labels-form">
        <FormControl>
          <OutlinedInput
            placeholder="Please enter new label"
            id="newLabel"
            name="newLabel"
            type="text"
            value={newLabel}
            rows={2}
            onChange={(e) => {
              setNewLabel(e.target.value);
            }}
          />
          <p className={errClass}>{errorAdd?.data?.message}</p>
          <Divider />
          {ids?.map((labelId, i) => {
            return (
              <ShortCutLabelsList
                key={i}
                labelId={labelId}
                onChecked={checkedLabels(labelId)}
                onCheckedLabels={props.handleCheckedLabels}
              />
            );
          })}
          <Divider />
          <AddNewLabelBtn label={newLabel} onAddClick={onAddNewLabelClicked} />
        </FormControl>
      </div>
    );
  }
  return content;
}

export default ShortCutLabelsForm;
